// extracted by mini-css-extract-plugin
module.exports = {"options":"styles_options_1AQD7GsNSvLgjG6OJlygVG","empty":"styles_empty_2oNWb2JnJ6IeUdVFCnf7WZ"};